import React, {FC} from 'react';
import {Router} from '@reach/router';
import ModuleCertificate from '.';
import Helmet from 'react-helmet';

interface Props {
  pageData: any,
}

const ModuleCertificateRouter:FC<Props> = ({pageData}) => {
  const title = `I've completed a course from Upskillist`;
  const metaDescription = `Upskillist is a certified online learning company
    providing high quality courses globally across a wide range of subjects.
    I have successfully completed a course, check out my certificate.`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image"
          content={`${process.env.AssetsCDN}/certificates/merit.png`} />
        {/* <meta property="og:url" content={ogUrl} /> */}
        <meta property="og:type" content="website" />
        <meta name="googlebot" content="noindex" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content={process.env.WebsiteDomain} />
        {/* <meta property="twitter:url" content="https://www-staging.upskillist.com/certificate/en/Q7bIQx7p/32accrpzakpcqi5i9232af34sdu1e8fo" /> */}
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image"
          content={`${process.env.AssetsCDN}/certificates/generic.png`} />
      </Helmet>
      <Router basepath="/certificate/en">
        <ModuleCertificate path='/:formId/:responseId' pageData={pageData} />
      </Router>
    </>
  );
};

export default ModuleCertificateRouter;
